import cx from "clsx";
import React from "react";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  content?: React.ReactNode;
  children?: React.ReactNode;
};

export function createContainer<T extends HTMLElement>(
  Component: keyof React.ReactHTML,
  defaultClassName: string
) {
  const component = React.forwardRef<T, Props>(
    ({ className, style, content, children = content }: Props) => (
      <Component className={cx(className, defaultClassName)} style={style}>
        {children}
      </Component>
    )
  );

  component.displayName = `createContainer(${Component})`;

  return component;
}
